import { Helmet } from "react-helmet-async";

interface PageHeadProps {
  title: string;
  description?: string;
  canonicalPath?: string;
  ogImage?: string;
  jsonLd?: object | object[];
  noIndex?: boolean;
}

const BASE_URL = "https://outspoken.co.in";
const DEFAULT_OG_IMAGE = `${BASE_URL}/outspoken-og-share.jpg`;
const DEFAULT_DESC = "Ancient decision science for modern professionals. Outspoken applies the Bhagavad Gita, Arthashastra, Ramayan, and Mahabharata as structured decision frameworks for career, relationships, and high-stakes life decisions.";

export default function PageHead({ title, description, canonicalPath, ogImage, jsonLd, noIndex }: PageHeadProps) {
  const desc = description || DEFAULT_DESC;
  const canonical = canonicalPath ? `${BASE_URL}${canonicalPath}` : undefined;
  const image = ogImage || DEFAULT_OG_IMAGE;

  const jsonLdBlocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={desc} />
      <meta name="application-name" content="Outspoken" />
      <meta name="context" content="Outspoken is India's Dharmic Intelligence Platform — ancient decision science for modern professionals. It applies the Bhagavad Gita, Arthashastra, Ramayan, and Mahabharata as structured decision frameworks for career, relationships, and high-stakes life decisions." />

      {noIndex && <meta name="robots" content="noindex, nofollow, noarchive, nosnippet" />}

      <meta property="og:title" content={title} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {canonical && <link rel="canonical" href={canonical} />}

      {jsonLdBlocks.map((block, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(block)}</script>
      ))}
    </Helmet>
  );
}
